<template>
    <div class="full-modal">
        <div class="btn-exit grow-medium" @click="ExitModal"><i class="pi pi-times"></i></div>
        <h1 class="top-text">Edit Benefit</h1>
        <div class="add-new">
            <div class="data-row">
                <h4 class="data-row-text">Name:</h4>
                <input class="data-row-input hover-grow" :class="{'input-incorrect': (this.benefit.name === '' && this.userTriedToClick)}" type="text" v-model="benefit.name"/>
            </div>
            <div class="data-row">
                <h4 class="data-row-text">Code:</h4>
                <input class="data-row-input hover-grow" :class="{'input-incorrect': (this.benefit.code === '' && this.userTriedToClick || !this.isCodeValid)}" type="text" v-model="benefit.code"/>
            </div>
            <div class="data-row" v-if="this.mode !== 'addon'">
                <h4 class="data-row-text">With each visit?</h4>
                <div class="checkbox-container grow-medium" style="position:relative;">
                    <div class="checkbox" @click="handleCheckboxClick()">
                        <div class="checkbox-fill" v-if="this.benefitFrequency === -1">
                            <p class="checkbox-text">✓</p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="data-row" v-if="this.benefitFrequency !== -1 && this.mode !== 'addon'">
                <h4 class="data-row-text no-select">Frequency:</h4>
                <div>
                    Every &nbsp;<input class="data-row-input hover-grow" style="width: 2.5em;" :class="{'input-incorrect': (this.benefit.price === 0 && this.userTriedToClick)}" type="text" v-model="benefit.frequencies[this.planType]" @input="ValidateFrequency($event)"/> &nbsp;Months
                </div>
            </div>
            <div class="data-row" v-if="this.mode !== 'addon' && canChangeQuantity">
                <h4 class="data-row-text no-select">Quantity:</h4>
                <div class="quantity-control">
                    <div class="plus-minus-buttons">
                        <PlusMinusButton class="plus-minus" :char="'+'" @plusMinusClick="UpdateQuantity"/>
                        <PlusMinusButton class="plus-minus" :char="'-'" @plusMinusClick="UpdateQuantity"/>
                    </div>
                    <div class="quantity-box no-select">{{ quantityForPlanType }}</div>
                </div>
            </div>
            <div class="data-row">
                <h4 class="data-row-text">UCR:</h4>
                <input class="data-row-input hover-grow" :class="{'input-incorrect': (this.benefit.UCR === 0 && this.userTriedToClick)}" type="text" v-model="benefit.UCR" @input="ValidateUCR($event)"/>
            </div>
            <div class="data-row" v-if="mode !== 'addon'">
                <h4 class="data-row-text">Desired Payout:</h4>
                <input class="data-row-input hover-grow" type="text" v-model="benefit.price" @input="ValidatePrice($event)"/>
            </div>
                <button class="submit-btn hover-grow" @click="SaveBenefit">Save</button>
                <div class="modal-bottom-spacer"></div>
            </div>
            <p class="error-message" :class="{ 'hidden': !(hasDefaultValues && userTriedToClick) || isCodeValid }">{{ errorMessage }}</p>

        <!-- Price Change Confirmation Modal -->
        <ChangePriceAlertModal
            :show="showPriceChangeConfirmation"
            :benefit="benefit"
            @cancel="cancelSave"
            @confirm="handlePriceChangeConfirmed"
        />
    </div>
</template>

<script>
import { mapActions } from 'vuex';
import { ValidateBenefitCode, canBenefitHaveMultipleQuantity } from '../../utils/functions';
import ChangePriceAlertModal from './ChangePriceAlertModal.vue';
import PlusMinusButton from '../PlusMinusButton.vue';

export default {
    components: {
        ChangePriceAlertModal,
        PlusMinusButton
    },
    props: {
        propBenefit: Object,
        planType: Number,
        mode: String
    },
    data() {
        return {
            benefit: null,
            originalPrice: null,
            selectedOption: "Add Existing Benefit",
            createNewBenefit: false,
            selectedDropDownItem: "",
            userTriedToClick: false,
            showPriceChangeConfirmation: false,
            inputClasses: {
                'data-row-input': true,
                'hover-grow': true,
            }
        }
    },
    created() {
        window.addEventListener('keydown', this.handleEscape);
        this.benefit = JSON.parse(JSON.stringify(this.propBenefit));
        this.originalPrice = this.benefit.price;
    },
    beforeDestroy() {
        window.removeEventListener('keydown', this.handleEscape);
    },
    methods: {
        ...mapActions(['addBenefitStore', 'updateBenefitByIDStore']),
        ExitModal() {
            this.$emit('exitModal');
        },
        
        SaveBenefit() {
            this.userTriedToClick = true;
            if(this.hasDefaultValues) {
                return;
            }
            
            // Check if price changed and benefit is on multiple plans and session-wide flag not set
            if(this.priceHasChanged && this.isOnMultiplePlans && !this.$store.state.allowMultiPlanPriceChanges) {
                this.showPriceChangeConfirmation = true;
                return;
            }
            
            this.confirmSave();
        },
        confirmSave() {
            //console.log("Entering updateByID in EditDetailsModal")
            this.updateBenefitByIDStore(this.benefit)
            this.$emit('recalculatePrices');
            this.ExitModal();
        },
        handlePriceChangeConfirmed() {
            // The modal has already set the session-wide flag in the store
            // No need to sync anything - the flag is session-wide
            this.showPriceChangeConfirmation = false;
            this.confirmSave();
        },
        cancelSave() {
            this.showPriceChangeConfirmation = false;
        },
        ValidatePrice(event) {
            const cleanedPrice = event.target.value.replace(/\D/g, '');
            this.benefit.price = parseInt(cleanedPrice, 10) || 0;
        },
        ValidateUCR(event) {
            const cleanedPrice = event.target.value.replace(/\D/g, '');
            this.benefit.UCR = parseInt(cleanedPrice, 10) || 0;
        },
        ValidateFrequency(event) {
            const cleanedFrequency = event.target.value.replace(/\D/g, '');
            this.benefit.frequencies[this.planType] = parseInt(cleanedFrequency, 10) || 0;
        },
        handleEscape(event) {
            if(event.key === 'Escape') {
                if(this.showPriceChangeConfirmation) {
                    this.cancelSave();
                } else {
                    this.ExitModal();
                }
            }
        },
        handleCheckboxClick() {
            if(this.benefitFrequency === -1) {
                this.benefit.frequencies[this.planType] = 6
            }
            else {
                this.benefit.frequencies[this.planType] = -1
            }
        },
        ValidateQuantity(event) {
            const n = Math.max(1, Math.floor(parseInt(event.target.value, 10) || 1));
            this.setQuantity(n);
        },
        UpdateQuantity(delta) {
            const n = Math.max(1, this.quantityForPlanType + delta);
            this.setQuantity(n);
        },
        setQuantity(n) {
            const planTypes = [...(this.benefit.planTypes || [])];
            const entry = planTypes.find(e => e.planTypeIndex === this.planType);
            if (entry) {
                entry.quantity = n;
            } else {
                planTypes.push({ planTypeIndex: this.planType, quantity: n });
            }
            this.benefit.planTypes = planTypes;
        },
    },
    computed: {
        codes() {
            let result = this.$store.state.benefits;
            result = result.filter(benefit => !benefit.planTypes.some(e => e.planTypeIndex === this.planType));
            return result;
        },
        hasDefaultValues() {
            if(this.benefit.name === "" || !this.isCodeValid || this.benefit.UCR === 0) {
                return true;
            }
            else {return false;}
        },
        isOnMultiplePlans() {
            if (!this.benefit.planTypes || !this.benefit.planTypes.length) return false;
            const entry = this.benefit.planTypes.find(e => e.planTypeIndex === this.planType);
            return this.benefit.planTypes.length > 1 || (entry && entry.quantity > 1);
        },
        quantityForPlanType() {
            const entry = this.benefit.planTypes.find(e => e.planTypeIndex === this.planType);
            return entry ? entry.quantity : 1;
        },
        canChangeQuantity() {
            return canBenefitHaveMultipleQuantity(this.benefit);
        },
        priceHasChanged() {
            return this.benefit.price !== this.originalPrice;
        },
        benefitFrequency() {
            return this.benefit.frequencies[this.planType];
        },
        isCodeValid() {
            return ValidateBenefitCode(this.benefit.code);
        },
        errorMessage() {
            if(!this.isCodeValid && this.benefit.code !== "") {
                return "Codes must be comma-separated & in the format D####"
            }
            else {
                return "Please fill out all fields to add this benefit"
            }
        }
    },
}
</script>

<style scoped>

.full-modal {
    position: relative;
    width: 30%;
    min-width: 280px;
    max-height: 90vh;
    background-color: white;
    display: flex;
    flex-direction: column;
    align-items: center;
    border-radius: 20px;
    border: 3px solid var(--color-dark-blue);
    outline: 2px solid white;
    padding: 2%;
    overflow-y: auto;
    box-sizing: border-box;
}

.btn-exit {
    position: absolute;
    top: 20px;
    right: 25px;
    color: red;
    font-size: 1.75em;
    cursor: pointer;
    font-family: sans-serif
}

.top-text {
    color: var(--font-color-teal);
    margin-top: 0.25em;
    flex-shrink: 0;
}

.add-existing {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
}

select {
    background-color: white;
    border: 2px solid var(--color-light-gray);
    border-radius: 5px;
    padding: 5px 10px;
    font-size: 16px;
    cursor: pointer;
}

select:hover {
    border: 2px solid var(--color-light-blue);
}

.add-new {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    flex-shrink: 0;
    gap: 0;
}

.data-row{
    width: 85%;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    height: 3em;
    flex-shrink: 0;
}

.data-row-text {
    font-size: 1.2em;
}

.data-row-input {
    height: 20px;
    border-radius: 5px;
    border: 2px solid var(--color-medium-light-gray);
    transition: border-color 0.2s ease;
}

.input-incorrect {
    border: 2px solid var(--color-light-red) !important;
}

.data-row-input:hover {
    border: 2px solid var(--color-light-blue);
}

.data-row-input:focus {
    outline: none;
    border: 2px solid var(--color-bright-blue);
}

.checkbox {
    position: relative;
    margin-right: 9.4em;
    margin-bottom: 2em;
}

.submit-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    border: 3px solid var(--color-light-blue);
    border-radius: 40px;
    height: 2.25em;
    min-height: 2.25em;
    background-color: white;
    color: var(--color-bright-blue);
    font-size: 1.4em;
    font-weight: 600;
    padding-right: 0.7em;
    padding-left: 0.7em;
    cursor: pointer;
    margin-top: 1em;
    box-shadow: 3px 3px 5px var(--color-light-gray);
    flex-shrink: 0;
}

.submit-btn:active {
    border: 3px solid var(--color-dark-blue)
}

.error-message {
    margin: 0;
    padding-bottom: 0.5em;
    color: var(--color-medium-red);
    flex-shrink: 0;
}

.error-message.hidden {
    visibility: hidden;
}

.modal-bottom-spacer {
    min-height: 0.5em;
    flex-shrink: 0;
}

.checkbox-container {
    cursor: pointer;
    position: relative;
    width: auto;
    height: 25px;
    margin-right: 85px;
}

.checkbox {
    position: absolute;
    width: 25px;
    height: 25px;
    border: 2px solid var(--color-dark-blue);
    border-radius: 5px;
    margin: 0;
}

.checkbox-fill {
    position: absolute;
    top: 1px;
    left: 1px;
    width: 23px;
    height: 23px;
    background-color: var(--color-dark-blue);
    border-radius: 3px;
    color: white;
}

.checkbox-text {
    margin: 0;
    position: absolute;
    font-size: 1.5em;
    left: 2px;
    top: -3px;
}

.quantity-control {
    display: flex;
    align-items: center;
    gap: 0.35em;
    --plus-minus-button-size: 17.25px; /* 75% of default 23px */
}

.quantity-control .plus-minus-buttons {
    display: flex;
    flex-direction: column;
    gap: 0;
}

.quantity-box {
    font-size: 1.4em;
    color: var(--color-bright-blue);
    background-color: white;
    border: 2px solid var(--color-light-blue);
    border-radius: 10px;
    min-width: 2.2em;
    padding: 0.2em 0.4em;
    text-align: center;
}
</style>